import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import PortalContratos from './PortalContratos';
import PortalCertificados from './PortalCertificados';
import PortalInformes from './PortalInformes';
import PortalPartes from './PortalPartes';
import PortalDocumentos from './PortalDocumentos';

export default function PortalDocumentosHub() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold">Documentos</h1>
        <p className="text-muted-foreground">Toda la documentación de tu empresa en un único lugar</p>
      </div>
      <Tabs defaultValue="contratos" className="w-full">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="contratos">Contratos</TabsTrigger>
          <TabsTrigger value="certificados">Certificados</TabsTrigger>
          <TabsTrigger value="informes">Informes</TabsTrigger>
          <TabsTrigger value="partes">Partes</TabsTrigger>
          <TabsTrigger value="otros">Otros documentos</TabsTrigger>
        </TabsList>
        <TabsContent value="contratos" className="mt-4">
          <PortalContratos />
        </TabsContent>
        <TabsContent value="certificados" className="mt-4">
          <PortalCertificados />
        </TabsContent>
        <TabsContent value="informes" className="mt-4">
          <PortalInformes />
        </TabsContent>
        <TabsContent value="partes" className="mt-4">
          <PortalPartes />
        </TabsContent>
        <TabsContent value="otros" className="mt-4">
          <PortalDocumentos />
        </TabsContent>
      </Tabs>
    </div>
  );
}

